import { render, staticRenderFns } from "./RelocationControl.vue?vue&type=template&id=f9d08590&scoped=true&"
import script from "./RelocationControl.vue?vue&type=script&lang=js&"
export * from "./RelocationControl.vue?vue&type=script&lang=js&"
import style0 from "./RelocationControl.vue?vue&type=style&index=0&id=f9d08590&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9d08590",
  null
  
)

export default component.exports